import { render, staticRenderFns } from "./PresetRegimen.vue?vue&type=template&id=02ed8d9b&scoped=true"
import script from "./PresetRegimen.vue?vue&type=script&lang=js"
export * from "./PresetRegimen.vue?vue&type=script&lang=js"
import style0 from "./PresetRegimen.vue?vue&type=style&index=0&id=02ed8d9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ed8d9b",
  null
  
)

export default component.exports